import { render, staticRenderFns } from "./ConsentGroupUpdate.vue?vue&type=template&id=095a9af4&scoped=true&"
import script from "./ConsentGroupUpdate.vue?vue&type=script&lang=js&"
export * from "./ConsentGroupUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ConsentGroupUpdate.vue?vue&type=style&index=0&id=095a9af4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095a9af4",
  null
  
)

export default component.exports